const lazyLoad = view => () => import(`@/modules-v2/exim/views/${view}`);

const eximRoute = [
  {
    path: '/exim-master-indent-creation/:type',
    name: 'EximMasterCreateIndent',
    component: lazyLoad('exim_form_container'),
    props: true,
    meta: {
      title: 'Exim Master Indent Creation',
      requiresAuth: true,
    },
  },
  {
    path: '/exim-master-indent-list',
    name: 'EximMasterIndent',
    component: lazyLoad('exim_listing_container'),
    meta: {
      title: 'Exim Master Indent Listing',
      requiresAuth: true,
    },
  },
  {
    path: '/exim-master-indent-edit/:orderId/:type',
    name: 'EximMasterEditIndent',
    component: lazyLoad('exim_form_container'),
    props: true,
    meta: {
      title: 'Exim Master Indent Edit',
      requiresAuth: true,
    },
  },
  {
    path: '/exim-master-indent-edit/:orderId/:type/:noEdit',
    name: 'EximMasterReIndent',
    component: lazyLoad('exim_form_container'),
    meta: {
      title: 'Exim Master Indent Edit',
      requiresAuth: true,
    },
  },
  {
    path: '/exim-master-indent-document/:orderId',
    name: 'EximMasterDocuments',
    component: lazyLoad('exim_master_documents'),
    meta: {
      title: 'Exim Master Indent Documents',
      requiresAuth: true,
    },
  },
];
export default eximRoute;
